<!--<div class="card card-box mb-5">-->
<!--  <div class="card-header py-3">-->
<!--    <div class="card-header&#45;&#45;title font-size-lg">-->
<!--      <b><i class="far fa-star"></i> Riviews </b>-->
<!--    </div>-->
<!--    <div class="card-header&#45;&#45;actions">-->
<!--      &lt;!&ndash;      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="createModal()">&ndash;&gt;-->
<!--      &lt;!&ndash;                <span class="btn-wrapper&#45;&#45;icon">&ndash;&gt;-->
<!--      &lt;!&ndash;                    <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>&ndash;&gt;-->
<!--      &lt;!&ndash;                </span>&ndash;&gt;-->
<!--      &lt;!&ndash;        <span class="btn-wrapper&#45;&#45;label">&ndash;&gt;-->
<!--      &lt;!&ndash;                    New User&ndash;&gt;-->
<!--      &lt;!&ndash;                </span>&ndash;&gt;-->
<!--      &lt;!&ndash;      </button>&ndash;&gt;-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="d-flex justify-content-between px-4 py-3">-->
<!--    <div class="search-wrapper">-->
<!--          <span class="icon-wrapper text-black">-->
<!--            <fa-icon [icon]="['fas', 'search']"></fa-icon>-->
<!--          </span>-->
<!--      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="divider"></div>-->
<!--  <div class="table-responsive">-->
<!--    <table class="table table-hover text-nowrap mb-0">-->
<!--      <thead>-->
<!--      <tr>-->
<!--        <th class="bg-white text-center">CLIENT</th>-->
<!--        <th class="bg-white text-center">REVIEW</th>-->
<!--        <th class="bg-white text-center">VIEW MORE</th>-->
<!--&lt;!&ndash;        <th class="bg-white text-center">Actions</th>&ndash;&gt;-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <tr *ngFor="let pac of reviwes">-->
<!--        <td class="font-weight-bold text-center">-->
<!--          {{pac.clientName}}-->
<!--        </td>-->
<!--        <td class="text-center">-->
<!--          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">-->
<!--            {{(pac.review | slice:0:40)+ '...'}}-->
<!--          </span>-->
<!--        </td>-->

<!--        <td class="font-weight-bold text-center">-->
<!--          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">-->
<!--            <button  type="button" class="btn btn-warning" (click)="viewMore(pac)">-->
<!--              <i class="fas fa-eye"></i>-->
<!--            </button>-->
<!--          </div>-->
<!--        </td>-->

<!--&lt;!&ndash;        <td class="text-center">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;            <button type="button" class="btn btn-success" (click)="approve(pac.id)" ><i class="fas fa-check-circle"></i></button>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;            <button type="button" class="btn btn-danger" (click)="reject(pac.id)"><i&ndash;&gt;-->
<!--&lt;!&ndash;              class="far fa-trash-alt"></i></button>&ndash;&gt;-->

<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </td>&ndash;&gt;-->
<!--      </tr>-->

<!--      </tbody>-->
<!--    </table>-->
<!--  </div>-->
<!--  <div class="card-footer py-3 d-flex justify-content-between">-->

<!--  </div>-->
<!--</div>-->

<!--<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"-->
<!--     role="dialog" aria-labelledby="dialog-sizes-name1">-->
<!--  <div *ngIf="view!=null" class="modal-dialog modal-dialog-centered modal-lg">-->
<!--    <div class="modal-content">-->
<!--      <div class="modal-header">-->
<!--        <h6 class="modal-title">Client review</h6>-->
<!--        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">-->
<!--          <span aria-hidden="true">&times;</span>-->
<!--        </button>-->
<!--      </div>-->
<!--      <div class="modal-body">-->
<!--        <div class="card-body">-->
<!--          <h4>Review</h4>-->
<!--          <p>{{view.review}}</p>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="modal-footer">-->
<!--        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>-->
<!--        &lt;!&ndash;        <button type="button" class="btn btn-primary ml-auto" (click)="addModal.hide()">Save changes</button>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<div class="card">
  <div class="card-body">
    <h4><b>Review</b></h4>
    <p class="text-muted">Below are review detail</p>
    <div class="row">
      <div class="col-12 mb-3" *ngFor="let pac of reviwes">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-2">
                <img class="img" src="assets/images/download.png" alt="" style="width: 5rem;">
              </div>
              <div class="col-3">
                <h5 class="mt-3"><b>{{pac.clientName}}</b></h5>
                <p class="text-muted">{{pac.clientEmail}}</p>
              </div>
              <div class="col-4">
                <p>{{pac.review}}</p>
              </div>
              <div class="col-2" *ngIf="pac.status==5">
                <div class="mb-2">
                  <button class="btn btn-success " style="width: 110px;" (click)="approve(pac)">Approve</button>
                </div>
                <div>
                  <button (click)="reject(pac.id)"  class="btn btn-danger " style="width: 110px;">Decline</button>
                </div>
              </div>
              <div class="col-2" *ngIf="pac.status==1">
                <button class="btn m-2 btn-neutral " type="button">Approved</button>
              </div>
              <div class="col-2" *ngIf="pac.status==9">
                <button class="btn m-2 btn-neutral-danger" type="button">Rejected</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer py-3 d-flex justify-content-between">
        <pagination [totalItems]="totalRec" [(ngModel)]="currentPage" (pageChanged)="getAllClientReviews($event.page)" class="pagination-icons pagination-warning"></pagination>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>

